// extracted by mini-css-extract-plugin
export default {"answersContainer":"style_answersContainer__-o0uL","analysis":"style_analysis__RrYlG"};